function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _filter, _filter2, _filter3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBae2(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3432_330)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3432_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557 423.217H-57V423.524H557V423.217Z",
    fill: "#EBEBEB",
    style: (_ref2 = {
      fill: "#EBEBEB"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.9216 0.9216 0.9216)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.478 442.963H454.807V443.27H495.478V442.963Z",
    fill: "#EBEBEB",
    style: (_ref3 = {
      fill: "#EBEBEB"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.9216 0.9216 0.9216)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.738 446.301H339.066V446.608H349.738V446.301Z",
    fill: "#EBEBEB",
    style: (_ref4 = {
      fill: "#EBEBEB"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.9216 0.9216 0.9216)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.577 431.575H430.012V431.882H453.577V431.575Z",
    fill: "#EBEBEB",
    style: (_ref5 = {
      fill: "#EBEBEB"
    }, _defineProperty(_ref5, "fill", "color(display-p3 0.9216 0.9216 0.9216)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4572 433.636H7.41992V433.943H60.4572V433.636Z",
    fill: "#EBEBEB",
    style: (_ref6 = {
      fill: "#EBEBEB"
    }, _defineProperty(_ref6, "fill", "color(display-p3 0.9216 0.9216 0.9216)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1736 433.636H71.4004V433.943H79.1736V433.636Z",
    fill: "#EBEBEB",
    style: (_ref7 = {
      fill: "#EBEBEB"
    }, _defineProperty(_ref7, "fill", "color(display-p3 0.9216 0.9216 0.9216)"), _defineProperty(_ref7, "fillOpacity", 1), _ref7)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.484 438.815H104.445V439.122H219.484V438.815Z",
    fill: "#EBEBEB",
    style: (_ref8 = {
      fill: "#EBEBEB"
    }, _defineProperty(_ref8, "fill", "color(display-p3 0.9216 0.9216 0.9216)"), _defineProperty(_ref8, "fillOpacity", 1), _ref8)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M414.662 193.026C414.662 189.467 417.548 186.571 421.121 186.571C421.772 186.571 422.386 186.669 422.976 186.841C422.877 186.191 422.828 185.528 422.828 184.865C422.828 177.318 428.956 171.194 436.508 171.194C437.368 171.194 438.215 171.28 439.026 171.427C441.126 167.991 444.908 165.684 449.23 165.684C455.776 165.684 461.093 170.936 461.191 177.465C461.252 177.465 461.326 177.465 461.388 177.465C467.466 177.465 472.403 182.398 472.403 188.473C472.403 194.548 467.466 199.481 461.388 199.481H420.937C417.45 199.383 414.662 196.536 414.662 193.039V193.026Z",
    fill: "url(#paint0_linear_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M52.8438 163.88C52.8438 160.321 55.7296 157.425 59.303 157.425C59.9539 157.425 60.5679 157.523 61.1573 157.695C61.0591 157.044 61.01 156.381 61.01 155.719C61.01 148.171 67.1377 142.047 74.6899 142.047C75.5495 142.047 76.3968 142.133 77.2073 142.281C79.3072 138.844 83.0894 136.537 87.412 136.537C93.9572 136.537 99.2744 141.79 99.3727 148.318C99.4341 148.318 99.5078 148.318 99.5692 148.318C105.648 148.318 110.584 153.252 110.584 159.327C110.584 165.402 105.648 170.335 99.5692 170.335H59.1188C55.6313 170.237 52.8438 167.39 52.8438 163.892V163.88Z",
    fill: "url(#paint1_linear_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M218.919 70.4752H195.379C195.44 69.9107 195.477 69.3339 195.477 68.7571C195.477 60.2033 188.539 53.2695 179.979 53.2695C179.795 53.2695 179.599 53.294 179.415 53.294C177.474 48.0906 172.464 44.3721 166.582 44.3721C159.005 44.3721 152.865 50.5082 152.865 58.0802C152.865 58.0802 152.865 58.1048 152.865 58.117C146.148 58.4361 140.769 63.7868 140.426 70.4875H139.799C136.005 70.4875 132.91 73.5924 132.91 77.3722C132.91 81.1521 136.017 84.257 139.799 84.257H218.919C222.714 84.257 225.808 81.1521 225.808 77.3722C225.808 73.5924 222.714 70.4875 218.919 70.4875V70.4752Z",
    fill: "url(#paint2_linear_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M407.786 65.0417C404.102 59.1756 397.593 55.2607 390.164 55.2607C382.734 55.2607 376.005 59.3106 372.358 65.3363C371.4 65.0663 370.393 64.919 369.349 64.919C363.197 64.919 358.199 69.9016 358.199 76.0623C358.199 76.0623 358.199 76.0623 358.199 76.0745H352.317C349.259 76.0745 346.754 78.5781 346.754 81.6339C346.754 84.6897 349.259 87.1932 352.317 87.1932H372.603C376.3 92.9857 382.771 96.8515 390.151 96.8515C395.972 96.8515 401.24 94.4584 405.01 90.6049C405.366 90.6295 405.71 90.654 406.066 90.654C413.176 90.654 418.948 84.8983 418.948 77.7804C418.948 71.2515 414.085 65.8763 407.773 65.0417H407.786Z",
    fill: "url(#paint3_linear_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M131.498 234.16C129.013 230.203 124.624 227.562 119.613 227.562C114.602 227.562 110.063 230.294 107.603 234.358C106.957 234.176 106.278 234.077 105.574 234.077C101.424 234.077 98.0533 237.437 98.0533 241.593C98.0533 241.593 98.0533 241.593 98.0533 241.601H94.086C92.0236 241.601 90.334 243.289 90.334 245.35C90.334 247.412 92.0236 249.1 94.086 249.1H107.769C110.262 253.007 114.627 255.614 119.604 255.614C123.53 255.614 127.084 254 129.626 251.401C129.867 251.418 130.098 251.434 130.339 251.434C135.134 251.434 139.027 247.552 139.027 242.751C139.027 238.348 135.747 234.722 131.49 234.16H131.498Z",
    fill: "url(#paint4_linear_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M249.999 478.638C381.497 478.638 488.096 472.419 488.096 464.746C488.096 457.074 381.497 450.854 249.999 450.854C118.502 450.854 11.9023 457.074 11.9023 464.746C11.9023 472.419 118.502 478.638 249.999 478.638Z",
    fill: "url(#paint5_linear_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.59,
    filter: "url(#filter0_f_3432_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.439 242.459L246.502 245.01L50.3535 401.059L58.7162 411.386L59.8582 412.809L256.007 256.76L258.07 259.311L261.754 242.422L244.439 242.459Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M244.439 242.459L246.502 245.011L50.3535 401.151L58.7162 411.485L59.8582 412.908L256.007 256.768L258.07 259.321L261.754 242.422L244.439 242.459Z",
    fill: "url(#paint6_radial_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4824 412.074C21.4824 408.515 24.3682 405.619 27.9417 405.619C28.5925 405.619 29.2065 405.717 29.796 405.889C29.6977 405.238 29.6486 404.576 29.6486 403.913C29.6486 396.366 35.7763 390.242 43.3285 390.242C44.1881 390.242 45.0355 390.328 45.8459 390.475C47.9458 387.039 51.7281 384.731 56.0506 384.731C62.5959 384.731 67.9131 389.984 68.0113 396.513C68.0727 396.513 68.1464 396.513 68.2078 396.513C74.2864 396.513 79.223 401.446 79.223 407.521C79.223 413.596 74.2864 418.529 68.2078 418.529H27.7575C24.27 418.431 21.4824 415.584 21.4824 412.086V412.074Z",
    fill: "url(#paint7_linear_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M21.4824 412.074C21.4824 408.515 24.3682 405.619 27.9417 405.619C28.5925 405.619 29.2065 405.717 29.796 405.889C29.6977 405.238 29.6486 404.576 29.6486 403.913C29.6486 396.366 35.7763 390.242 43.3285 390.242C44.1881 390.242 45.0355 390.328 45.8459 390.475C47.9458 387.039 51.7281 384.731 56.0506 384.731C62.5959 384.731 67.9131 389.984 68.0113 396.513C68.0727 396.513 68.1464 396.513 68.2078 396.513C74.2864 396.513 79.223 401.446 79.223 407.521C79.223 413.596 74.2864 418.529 68.2078 418.529H27.7575C24.27 418.431 21.4824 415.584 21.4824 412.086V412.074Z",
    fill: "url(#paint8_radial_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.488 169.365L244.72 167.5C244.241 166.997 243.541 166.776 242.866 166.898L240.213 167.402C239.354 167.573 238.69 168.273 238.58 169.144L237.217 180.238L241.331 181.809C246.329 179.637 246.071 173.035 246.071 173.035L246.795 171.721C247.213 170.948 247.09 169.991 246.488 169.353V169.365Z",
    fill: "#FFB573",
    style: (_ref9 = {
      fill: "#FFB573"
    }, _defineProperty(_ref9, "fill", "color(display-p3 1.0000 0.7098 0.4510)"), _defineProperty(_ref9, "fillOpacity", 1), _ref9)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.913 202.611C196.913 202.611 200.843 202.844 203.151 202.795C205.472 202.758 207.793 202.721 210.065 202.586C212.337 202.439 214.584 202.279 216.647 201.997C217.666 201.85 218.661 201.666 219.447 201.457C219.815 201.347 220.172 201.236 220.331 201.175C220.601 201.052 220.307 201.261 220.454 201.175C220.835 200.844 221.584 199.96 222.235 199.138C222.91 198.279 223.585 197.358 224.261 196.426C225.612 194.548 226.95 192.597 228.276 190.633L236.295 178.741L242.558 182.079C241.637 184.374 240.642 186.583 239.635 188.817C238.604 191.026 237.548 193.235 236.455 195.431C235.35 197.628 234.195 199.813 232.955 201.997C232.329 203.089 231.678 204.182 230.953 205.298C230.204 206.44 229.529 207.507 228.227 208.919C227.527 209.692 226.25 210.637 225.427 211.042C224.519 211.533 223.745 211.84 222.971 212.134C221.461 212.674 220.098 213.018 218.747 213.324C216.07 213.926 213.516 214.269 210.974 214.515C205.89 215.018 201.002 215.214 195.906 215.092L196.876 202.611H196.913Z",
    fill: "#407BFF",
    style: (_ref10 = {
      fill: "#407BFF"
    }, _defineProperty(_ref10, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref10, "fillOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M242.571 182.079C241.65 184.362 240.655 186.571 239.66 188.804C238.616 191.013 237.56 193.222 236.467 195.431C235.362 197.616 234.22 199.8 232.968 201.985C232.341 203.077 231.69 204.169 230.966 205.286C230.229 206.427 229.541 207.495 228.252 208.906C227.552 209.68 226.275 210.612 225.452 211.017C224.543 211.52 223.77 211.827 222.996 212.122C221.486 212.662 220.123 213.005 218.784 213.3C216.107 213.901 213.553 214.257 211.011 214.503C209.918 214.613 208.837 214.699 207.769 214.785C203.827 215.067 199.947 215.165 195.943 215.079L196.14 212.502L196.913 202.599C196.913 202.599 200.843 202.844 203.152 202.783C205.485 202.746 207.794 202.709 210.078 202.574C212.337 202.439 214.597 202.279 216.66 201.985C217.679 201.85 218.674 201.666 219.46 201.445C219.828 201.347 220.184 201.236 220.344 201.163C220.614 201.04 220.319 201.261 220.467 201.175C220.847 200.844 221.596 199.96 222.247 199.138C222.923 198.279 223.598 197.358 224.261 196.426C225.612 194.548 226.95 192.597 228.289 190.633L236.308 178.741L242.571 182.079Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M207.769 214.785C203.827 215.067 199.947 215.165 195.943 215.08L196.14 212.502L197.098 210.244C197.098 210.244 203.532 210.158 207.769 214.785Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.24 422.763C131.24 422.763 120.127 415.117 120.802 409.988C120.864 409.484 120.569 409.043 120.041 408.957L110.622 407.533C110.18 407.472 109.713 407.668 109.455 408.036L103.893 415.829L106.398 416.737L107.736 415.792L108.362 417.449C121.944 422.358 127.851 424.334 130.847 424.457C131.67 423.401 131.24 422.763 131.24 422.763Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.844 278.392C193.844 278.392 193.279 279.865 192.285 282.417C191.216 285.179 189.644 289.204 187.753 293.99C186.488 297.181 185.089 300.715 183.578 304.434C176.64 321.664 167.676 342.981 161.744 353.744C150.385 374.337 120.79 413.448 120.79 413.448L108.965 409.129C108.965 409.129 130.258 368.851 141.003 348.442C144.282 342.22 148.052 333.065 151.785 323.075C153.566 318.326 155.334 313.38 157.041 308.484C157.815 306.275 158.576 304.066 159.313 301.893C161.265 296.15 163.095 290.615 164.704 285.682C164.9 285.068 165.097 284.454 165.293 283.865C165.944 281.84 166.558 279.926 167.111 278.159C169.419 270.894 170.856 266.107 170.905 265.923H170.917L181.466 271.667L193.844 278.392Z",
    fill: "#263238",
    style: (_ref11 = {
      fill: "#263238"
    }, _defineProperty(_ref11, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref11, "fillOpacity", 1), _ref11)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M192.285 282.417C191.216 285.178 189.644 289.204 187.753 293.99C186.488 297.181 185.089 300.715 183.578 304.434C173.926 306.373 164.102 307.686 157.041 308.483C157.815 306.274 158.576 304.065 159.313 301.893C161.265 296.15 163.095 290.615 164.704 285.682C164.9 285.068 165.097 284.454 165.293 283.865C165.944 281.84 166.558 279.926 167.111 278.159C174.208 279.128 183.701 280.576 192.285 282.417Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.058 209.139C156.058 209.139 156.058 209.152 156.058 209.164C157.765 214.871 158.759 221.51 159.312 228.051C159.742 233.144 159.901 238.151 159.926 242.643C159.938 247.171 159.803 251.184 159.656 254.252C159.459 258.192 159.226 260.622 159.226 260.622L196.533 262.536C207.732 221.988 196.901 202.598 196.901 202.598C196.901 202.598 192.247 202.132 186.893 202.365C186.205 202.39 185.505 202.439 184.781 202.5C180.213 202.881 172.943 204.316 168.092 205.421C167.097 205.642 166.091 205.899 165.108 206.169C160.233 207.495 156.033 209.139 156.033 209.139H156.058Z",
    fill: "#407BFF",
    style: (_ref12 = {
      fill: "#407BFF"
    }, _defineProperty(_ref12, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref12, "fillOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M196.544 262.536L159.238 260.621C159.238 260.621 159.471 258.191 159.668 254.24C159.717 253.086 159.766 251.773 159.815 250.349C159.889 248.054 159.938 245.453 159.938 242.642C159.938 241.28 159.901 239.869 159.864 238.421C159.864 238.188 159.852 237.954 159.852 237.721C159.79 235.426 159.68 233.045 159.52 230.628C159.446 229.769 159.385 228.91 159.311 228.051C159.262 227.376 159.201 226.688 159.139 226.013C158.955 224.295 158.759 222.577 158.513 220.884C158.452 220.417 158.378 219.951 158.304 219.497C158.194 218.724 158.071 217.975 157.936 217.214C157.433 214.416 156.819 211.692 156.069 209.151C156.069 209.151 156.057 209.139 156.045 209.139C156.045 209.139 160.257 207.495 165.132 206.157C166.102 205.899 167.109 205.641 168.104 205.421C172.967 204.328 180.237 202.88 184.792 202.5C185.517 202.451 186.217 202.389 186.917 202.377C192.259 202.132 196.913 202.598 196.913 202.598C196.913 202.598 207.744 221.976 196.544 262.536Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.619 359.573C219.619 359.573 208.96 351.302 209.93 346.221C210.028 345.718 209.758 345.264 209.23 345.153L199.91 343.19C199.48 343.104 198.989 343.276 198.706 343.619L192.701 351.081L195.145 352.124L196.545 351.265L197.085 352.959C210.36 358.641 216.156 360.948 219.128 361.255C220.012 360.248 219.619 359.586 219.619 359.586V359.573Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.081 294.223C177.646 294.248 177.953 294.248 177.953 294.248L222.676 300.752L197.22 342.969L209.967 347.816C209.967 347.816 256.066 298.138 245.775 286.811C237.302 277.496 195.796 271.826 195.796 271.826L197.159 262.107L158.771 254.559C142.365 290.468 171.592 293.892 177.081 294.235V294.223Z",
    fill: "#263238",
    style: (_ref13 = {
      fill: "#263238"
    }, _defineProperty(_ref13, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref13, "fillOpacity", 1), _ref13)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.317 258.364L157.494 258.204L158.243 255.615L158.968 255.762L158.317 258.364Z",
    fill: "#263238",
    style: (_ref14 = {
      fill: "#263238"
    }, _defineProperty(_ref14, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref14, "fillOpacity", 1), _ref14)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.513 264.205L172.119 261.027L172.758 258.438L189.09 261.591L188.513 264.205Z",
    fill: "#263238",
    style: (_ref15 = {
      fill: "#263238"
    }, _defineProperty(_ref15, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref15, "fillOpacity", 1), _ref15)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.355 261.837L197.281 263.187L196.815 265.813L189.803 264.451L190.355 261.837Z",
    fill: "#263238",
    style: (_ref16 = {
      fill: "#263238"
    }, _defineProperty(_ref16, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref16, "fillOpacity", 1), _ref16)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.232 256.007L171.505 258.192L170.842 260.781L159.605 258.609L160.232 256.007Z",
    fill: "#263238",
    style: (_ref17 = {
      fill: "#263238"
    }, _defineProperty(_ref17, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref17, "fillOpacity", 1), _ref17)
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.317 258.364L157.494 258.204L158.243 255.615L158.968 255.762L158.317 258.364Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.513 264.205L172.119 261.027L172.758 258.438L189.09 261.591L188.513 264.205Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.355 261.837L197.281 263.187L196.815 265.813L189.803 264.451L190.355 261.837Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.232 256.007L171.505 258.192L170.842 260.781L159.605 258.609L160.232 256.007Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.969 261.113L183.601 262.696C183.54 262.954 183.294 263.113 183.036 263.064L178.935 262.34C178.652 262.291 178.48 262.021 178.542 261.739L178.959 260.094C179.021 259.849 179.266 259.689 179.524 259.738L183.589 260.524C183.859 260.573 184.031 260.843 183.969 261.113Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.786163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.567 261.248L179.314 261.027",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.786163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.985 188.51L181.735 196.585C180.777 200.537 182.435 204.181 184.363 204.856C184.363 204.856 185.788 208.244 183.049 208.82C177.499 209.974 171.162 204.599 171.162 204.599C174.097 201.445 173.041 193.566 171.997 188.522L171.985 188.51Z",
    fill: "#EBB376",
    style: (_ref18 = {
      fill: "#EBB376"
    }, _defineProperty(_ref18, "fill", "color(display-p3 0.9216 0.7020 0.4627)"), _defineProperty(_ref18, "fillOpacity", 1), _ref18)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.951 191.799L181.723 196.573C181.489 197.505 181.317 198.45 181.256 199.371C179.095 199.101 176.111 196.781 175.853 194.536C175.73 193.406 175.767 192.327 175.951 191.799Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.593 172.556C182.95 174.029 186.143 178.459 182.177 179.514C178.21 180.582 176.528 170.028 180.593 172.556Z",
    fill: "#263238",
    style: (_ref19 = {
      fill: "#263238"
    }, _defineProperty(_ref19, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref19, "fillOpacity", 1), _ref19)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.411 187.688C172.537 193.124 174.674 196.511 179.463 197.493C186.672 198.954 191.903 191.627 189.484 185.049C187.298 179.134 180.925 171.243 173.9 172.74C166.975 174.213 164.298 182.263 168.411 187.7V187.688Z",
    fill: "#FFB573",
    style: (_ref20 = {
      fill: "#FFB573"
    }, _defineProperty(_ref20, "fill", "color(display-p3 1.0000 0.7098 0.4510)"), _defineProperty(_ref20, "fillOpacity", 1), _ref20)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.626 181.772L164.677 175.992C164.677 175.992 158.132 180.803 161.104 183.711C159.139 188.314 166.925 194.744 173.728 193.419C174.514 189.271 168.46 182.165 168.46 182.165C168.828 182.055 169.221 181.907 169.626 181.76V181.772Z",
    fill: "#263238",
    style: (_ref21 = {
      fill: "#263238"
    }, _defineProperty(_ref21, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref21, "fillOpacity", 1), _ref21)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.37 193.873C170.794 195.026 172.624 195.419 174.122 195.223C176.369 194.94 176.64 192.695 175.289 191.013C174.073 189.504 171.433 187.835 169.529 188.964C167.651 190.081 167.749 192.547 169.382 193.873H169.37Z",
    fill: "#FFB573",
    style: (_ref22 = {
      fill: "#FFB573"
    }, _defineProperty(_ref22, "fill", "color(display-p3 1.0000 0.7098 0.4510)"), _defineProperty(_ref22, "fillOpacity", 1), _ref22)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.027 183.454C178.334 183.92 178.825 184.129 179.132 183.92C179.427 183.711 179.427 183.171 179.12 182.717C178.813 182.251 178.321 182.042 178.014 182.251C177.72 182.459 177.72 182.999 178.027 183.454Z",
    fill: "#263238",
    style: (_ref23 = {
      fill: "#263238"
    }, _defineProperty(_ref23, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref23, "fillOpacity", 1), _ref23)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.22 179.932C183.527 180.398 184.018 180.607 184.325 180.398C184.62 180.189 184.62 179.649 184.313 179.195C184.006 178.729 183.515 178.52 183.208 178.729C182.913 178.938 182.913 179.477 183.22 179.932Z",
    fill: "#263238",
    style: (_ref24 = {
      fill: "#263238"
    }, _defineProperty(_ref24, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref24, "fillOpacity", 1), _ref24)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.723 181.282C181.723 181.282 184.498 183.123 186.488 183.577C186.169 184.841 184.548 185.43 184.548 185.43L181.711 181.282H181.723Z",
    fill: "#ED893E",
    style: (_ref25 = {
      fill: "#ED893E"
    }, _defineProperty(_ref25, "fill", "color(display-p3 0.9294 0.5373 0.2431)"), _defineProperty(_ref25, "fillOpacity", 1), _ref25)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.286 188.559C180.089 188.67 179.881 188.792 179.672 188.952C179.598 189.001 179.586 189.111 179.635 189.185C179.684 189.259 179.795 189.271 179.856 189.222C181.833 187.786 183.736 188.498 183.761 188.51C183.847 188.547 183.933 188.51 183.97 188.412C184.007 188.326 183.97 188.228 183.872 188.203C183.798 188.179 182.152 187.565 180.274 188.571L180.286 188.559Z",
    fill: "#263238",
    style: (_ref26 = {
      fill: "#263238"
    }, _defineProperty(_ref26, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref26, "fillOpacity", 1), _ref26)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.478 181.944C174.588 181.944 174.711 181.895 174.772 181.797C175.558 180.57 176.762 180.533 176.774 180.533C176.958 180.533 177.105 180.385 177.093 180.201C177.081 180.017 176.946 179.882 176.762 179.882C176.7 179.882 175.19 179.919 174.207 181.441C174.109 181.588 174.158 181.797 174.306 181.895C174.355 181.932 174.404 181.944 174.465 181.944H174.478Z",
    fill: "#263238",
    style: (_ref27 = {
      fill: "#263238"
    }, _defineProperty(_ref27, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref27, "fillOpacity", 1), _ref27)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.282 175.735C183.282 175.735 183.306 175.612 183.282 175.551C183.233 175.379 183.048 175.268 182.876 175.317C181.145 175.796 180.691 177.232 180.666 177.293C180.617 177.465 180.703 177.649 180.875 177.698C181.047 177.747 181.231 177.661 181.28 177.49C181.292 177.428 181.661 176.336 183.048 175.943C183.159 175.919 183.233 175.833 183.269 175.735H183.282Z",
    fill: "#263238",
    style: (_ref28 = {
      fill: "#263238"
    }, _defineProperty(_ref28, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref28, "fillOpacity", 1), _ref28)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.46 182.19C168.46 182.19 181.428 176.741 182.214 170.531C183.012 164.321 177.535 166.862 177.535 166.862C177.535 166.862 180.065 166.69 179.819 168.531C179.819 168.531 175.435 165.548 171.272 168.113C171.272 168.113 173.225 168.077 174.244 169.525C174.244 169.525 170.278 170.298 165.832 173.587C161.387 176.876 153.405 188.669 168.448 182.19H168.46Z",
    fill: "#263238",
    style: (_ref29 = {
      fill: "#263238"
    }, _defineProperty(_ref29, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref29, "fillOpacity", 1), _ref29)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M195.796 271.826L174.662 269.396C174.662 269.396 183.025 268.022 196.263 268.513L195.796 271.826Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.52 230.628C159.447 229.769 159.385 228.91 159.312 228.051C159.263 227.376 159.201 226.689 159.14 226.014C158.956 224.296 158.759 222.578 158.513 220.884C158.452 220.418 158.378 219.951 158.305 219.497C158.87 219.043 159.496 218.626 160.159 218.258C160.159 218.258 161.362 224.455 159.52 230.628Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.314 260.781L120.643 269.396L128.588 271.36C128.588 271.36 132.002 265.702 128.674 261.383L124.314 260.781Z",
    fill: "#EBB376",
    style: (_ref30 = {
      fill: "#EBB376"
    }, _defineProperty(_ref30, "fill", "color(display-p3 0.9216 0.7020 0.4627)"), _defineProperty(_ref30, "fillOpacity", 1), _ref30)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.207 276.036L127.483 276.085L128.588 271.36L120.643 269.396L121.207 276.036Z",
    fill: "#EBB376",
    style: (_ref31 = {
      fill: "#EBB376"
    }, _defineProperty(_ref31, "fill", "color(display-p3 0.9216 0.7020 0.4627)"), _defineProperty(_ref31, "fillOpacity", 1), _ref31)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.062 215.104C160.602 220.504 158.76 222.7 158.76 222.7C158.76 222.7 153.529 225.989 151.257 227.671C149.329 229.119 147.438 230.604 145.645 232.076C144.761 232.825 143.902 233.574 143.116 234.322C142.342 235.059 141.617 235.832 141.151 236.421C140.942 236.654 140.733 237.047 140.525 237.39C140.303 237.746 140.07 238.286 139.825 238.728C139.346 239.722 138.867 240.765 138.412 241.87C137.504 244.067 136.644 246.349 135.834 248.669C134.127 253.283 132.555 258.045 130.922 262.72L123.664 261.002C124.401 255.909 125.396 250.951 126.55 245.92C127.152 243.416 127.827 240.913 128.601 238.372C128.981 237.096 129.423 235.807 129.915 234.482C130.209 233.782 130.443 233.156 130.811 232.408C131.204 231.647 131.56 230.911 132.088 230.125C133.071 228.653 134.028 227.548 135.011 226.48C135.981 225.425 136.951 224.455 137.933 223.51C139.886 221.633 141.888 219.927 143.926 218.282C147.991 214.981 152.068 211.962 156.439 209.054C156.439 209.054 159.583 210.232 160.074 215.128L160.062 215.104Z",
    fill: "#407BFF",
    style: (_ref32 = {
      fill: "#407BFF"
    }, _defineProperty(_ref32, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref32, "fillOpacity", 1), _ref32)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M160.062 215.104C160.602 220.504 158.76 222.7 158.76 222.7C158.76 222.7 153.529 225.989 151.257 227.671C149.329 229.119 147.438 230.604 145.645 232.076C144.761 232.825 143.902 233.574 143.116 234.322C142.342 235.059 141.617 235.832 141.151 236.421C140.942 236.654 140.733 237.047 140.525 237.39C140.303 237.746 140.07 238.286 139.825 238.728C139.346 239.722 138.867 240.765 138.412 241.87C137.504 244.067 136.644 246.349 135.834 248.669C134.127 253.283 132.555 258.045 130.922 262.72L123.664 261.002C124.401 255.909 125.396 250.951 126.55 245.92C127.152 243.416 127.827 240.913 128.601 238.372C128.981 237.096 129.423 235.807 129.915 234.482C130.209 233.782 130.443 233.156 130.811 232.408C131.204 231.647 131.56 230.911 132.088 230.125C133.071 228.653 134.028 227.548 135.011 226.48C135.981 225.425 136.951 224.455 137.933 223.51C139.886 221.633 141.888 219.927 143.926 218.282C147.991 214.981 152.068 211.962 156.439 209.054C156.439 209.054 159.583 210.232 160.074 215.128L160.062 215.104Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.554 207.864L179.28 212.147C179.28 212.147 169.763 223.683 151.54 227.487L150.324 231.193L154.192 232.212C154.192 232.212 173.865 227.119 181.724 212.368L185.777 207.851L181 206.244L176.542 207.864H176.554Z",
    fill: "#407BFF",
    style: (_ref33 = {
      fill: "#407BFF"
    }, _defineProperty(_ref33, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref33, "fillOpacity", 1), _ref33)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.725 205.274L172.17 201.396L181.012 206.244L182.031 200.942L186.697 203.63L188.036 210.477L181.515 207.667L175.694 212.858L167.725 205.274Z",
    fill: "#407BFF",
    style: (_ref34 = {
      fill: "#407BFF"
    }, _defineProperty(_ref34, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref34, "fillOpacity", 1), _ref34)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M167.725 205.274L172.17 201.396L181.012 206.244L182.031 200.942L186.697 203.63L188.036 210.477L181.515 207.667L175.694 212.858L167.725 205.274Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.529 128.523C289.529 128.523 281.277 138.758 272.89 137.911C264.515 137.064 260.229 140.464 260.229 140.464L259.406 144.551L263.901 143.949C263.901 143.949 263.901 140.709 272.644 141.077C281.387 141.446 287.945 133.923 290.499 130.523L289.529 128.535V128.523Z",
    fill: "#407BFF",
    style: (_ref35 = {
      fill: "#407BFF"
    }, _defineProperty(_ref35, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref35, "fillOpacity", 1), _ref35)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.841 111.513L348.669 110.703C348.583 110.384 348.632 110.347 348.325 109.549C347.847 108.31 347.036 107.279 346.324 106.641C344.85 105.316 343.622 104.849 342.566 104.432C340.466 103.683 338.796 103.45 337.138 103.254C335.493 103.07 333.946 102.984 332.411 102.947C329.353 102.861 326.406 103.008 323.483 103.192C317.625 103.585 311.989 104.272 306.205 105.266L308.317 117.355C313.61 116.508 319.136 115.735 324.478 115.182C327.155 114.912 329.832 114.741 332.386 114.667C333.663 114.63 334.916 114.642 336.082 114.716C336.893 114.765 337.703 114.851 338.305 114.962C338.342 115.379 338.354 115.833 338.342 116.312C338.268 118.398 337.74 120.84 337.028 123.27C335.591 128.154 333.319 133.235 330.986 137.984L336.819 141.862C340.54 137.162 343.61 132.265 346.14 126.645C347.355 123.81 348.424 120.815 348.915 117.306C349.148 115.551 349.234 113.624 348.854 111.501L348.841 111.513Z",
    fill: "#407BFF",
    style: (_ref36 = {
      fill: "#407BFF"
    }, _defineProperty(_ref36, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref36, "fillOpacity", 1), _ref36)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M348.903 117.306C348.51 120.202 347.699 122.755 346.754 125.148C346.557 125.651 346.348 126.154 346.14 126.645C343.598 132.266 340.528 137.15 336.807 141.85L330.986 137.972C333.319 133.223 335.579 128.154 337.028 123.258C337.519 121.576 337.924 119.883 338.145 118.312C338.256 117.612 338.317 116.937 338.342 116.299C338.354 115.821 338.342 115.367 338.305 114.949C337.703 114.839 336.893 114.753 336.082 114.704C334.916 114.63 333.663 114.63 332.386 114.655C332.288 114.655 332.202 114.667 332.104 114.667C329.623 114.753 327.057 114.925 324.465 115.183C319.283 115.723 313.954 116.459 308.808 117.281C308.637 117.306 308.477 117.33 308.317 117.355L306.205 105.254C312.001 104.26 317.625 103.573 323.483 103.18C326.406 102.996 329.353 102.849 332.411 102.935C333.946 102.972 335.493 103.058 337.138 103.242C338.796 103.45 340.466 103.683 342.566 104.42C343.622 104.837 344.838 105.303 346.324 106.629C347.036 107.267 347.847 108.298 348.325 109.537C348.62 110.335 348.583 110.372 348.669 110.691L348.841 111.501C349.222 113.624 349.136 115.538 348.903 117.306Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M332.104 114.667C329.623 114.753 327.057 114.925 324.466 115.183C319.283 115.723 313.954 116.459 308.809 117.281C310.687 112.667 312.615 108.003 312.615 108.003C312.615 108.003 321.211 108.826 332.104 114.667Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M346.754 125.148C346.557 125.651 346.349 126.154 346.14 126.645C343.598 132.266 340.528 137.15 336.807 141.85L330.986 137.972C333.32 133.223 335.579 128.154 337.028 123.258C337.519 121.576 337.925 119.883 338.146 118.312C340.982 120.214 343.88 122.472 346.754 125.148Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.274 113.943C268.605 114.373 268.654 114.888 268.384 115.109C268.102 115.33 267.611 115.158 267.279 114.741C266.947 114.312 266.898 113.796 267.168 113.575C267.451 113.354 267.942 113.526 268.274 113.943Z",
    fill: "#263238",
    style: (_ref37 = {
      fill: "#263238"
    }, _defineProperty(_ref37, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref37, "fillOpacity", 1), _ref37)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.703 114.852C268.703 114.852 269.673 118.067 269.538 120.08C270.84 120.19 271.871 118.865 271.871 118.865L268.703 114.852Z",
    fill: "#DE5753",
    style: (_ref38 = {
      fill: "#DE5753"
    }, _defineProperty(_ref38, "fill", "color(display-p3 0.8706 0.3412 0.3255)"), _defineProperty(_ref38, "fillOpacity", 1), _ref38)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.965 110.36C267.965 110.36 268.039 110.225 268.039 110.139C268.039 109.967 267.879 109.832 267.707 109.832C265.951 109.906 265.19 111.157 265.165 111.219C265.079 111.366 265.129 111.562 265.276 111.648C265.423 111.734 265.62 111.685 265.706 111.538C265.706 111.538 266.332 110.532 267.732 110.458C267.818 110.458 267.904 110.409 267.965 110.347V110.36Z",
    fill: "#263238",
    style: (_ref39 = {
      fill: "#263238"
    }, _defineProperty(_ref39, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref39, "fillOpacity", 1), _ref39)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.504 107.377C284.556 110.298 292.33 114.925 296.738 113.17C296.738 113.17 300.705 116.471 296.898 124.743C292.71 133.849 290.377 127.013 290.377 127.013C291.47 121.503 287.725 119.932 283.869 119.208L280.516 107.365L280.504 107.377Z",
    fill: "#E4897B",
    style: (_ref40 = {
      fill: "#E4897B"
    }, _defineProperty(_ref40, "fill", "color(display-p3 0.8941 0.5373 0.4824)"), _defineProperty(_ref40, "fillOpacity", 1), _ref40)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.732 101.855C285.527 107.316 288.032 110.323 287.516 115.072C286.73 122.227 278.416 124.915 273.062 120.693C268.236 116.901 262.833 108.592 266.308 102.493C269.722 96.4797 277.95 96.3815 281.744 101.843L281.732 101.855Z",
    fill: "#E4897B",
    style: (_ref41 = {
      fill: "#E4897B"
    }, _defineProperty(_ref41, "fill", "color(display-p3 0.8941 0.5373 0.4824)"), _defineProperty(_ref41, "fillOpacity", 1), _ref41)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.835 110.875C287.27 113.968 276.832 118.202 272.105 111.526C272.105 111.526 266.161 111.477 262.6 107.905C259.026 104.322 259.8 100.444 262.993 98.3329C265.817 96.4675 273.111 82.7717 281.609 92.5527C290.832 92.1722 288.56 107.009 287.848 110.875H287.835Z",
    fill: "#263238",
    style: (_ref42 = {
      fill: "#263238"
    }, _defineProperty(_ref42, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref42, "fillOpacity", 1), _ref42)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.213 96.8605C270.213 96.8605 264.736 96.5905 261.58 99.1063C258.424 101.61 259.308 109.305 260.524 110.765C261.74 112.225 263.029 112.213 263.029 112.213C263.029 112.213 261.163 111.244 261.163 109.832C261.163 109.832 261.973 111.734 265.694 112.213C265.694 112.213 264.638 111.366 264.798 110.286C264.798 110.286 266.811 112.9 271.478 110.286C276.144 107.672 270.201 96.8605 270.201 96.8605H270.213Z",
    fill: "#263238",
    style: (_ref43 = {
      fill: "#263238"
    }, _defineProperty(_ref43, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref43, "fillOpacity", 1), _ref43)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.868 110.384C275.875 111.808 276.268 113.587 276.182 115.035C276.047 117.207 274.229 117.379 272.805 116.005C271.515 114.778 270.042 112.164 270.877 110.347C271.7 108.568 273.726 108.752 274.868 110.384Z",
    fill: "#E4897B",
    style: (_ref44 = {
      fill: "#E4897B"
    }, _defineProperty(_ref44, "fill", "color(display-p3 0.8941 0.5373 0.4824)"), _defineProperty(_ref44, "fillOpacity", 1), _ref44)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.772 128.523C285.772 128.523 284.753 116.165 292.821 109.231L302.436 110.115C302.436 110.115 296.898 123.626 285.772 128.523Z",
    fill: "#407BFF",
    style: (_ref45 = {
      fill: "#407BFF"
    }, _defineProperty(_ref45, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref45, "fillOpacity", 1), _ref45)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M285.772 128.523C285.772 128.523 284.753 116.165 292.821 109.231L302.436 110.115C302.436 110.115 296.898 123.626 285.772 128.523Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.487 156.307C313.487 156.307 298.948 142.047 282.873 132.057C282.873 132.057 293.581 106.936 307.138 104.702C307.138 104.702 342.173 115.281 352.341 143.937L313.487 156.307Z",
    fill: "#407BFF",
    style: (_ref46 = {
      fill: "#407BFF"
    }, _defineProperty(_ref46, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref46, "fillOpacity", 1), _ref46)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.329 243.33L309.066 245.993L302.275 231.732L308.55 229.082L315.329 243.33Z",
    fill: "#E4897B",
    style: (_ref47 = {
      fill: "#E4897B"
    }, _defineProperty(_ref47, "fill", "color(display-p3 0.8941 0.5373 0.4824)"), _defineProperty(_ref47, "fillOpacity", 1), _ref47)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.34 143.937L348.644 183.171C346.606 184.68 343.376 185.846 339.459 186.755C331.796 188.534 321.579 189.344 312.75 189.823C302.84 190.363 294.698 190.461 293.961 191.038C292.242 192.375 314.064 237.427 314.064 237.427L303.65 238.728C303.65 238.728 276.278 201.199 272.729 188.166C271.428 183.355 270.114 177.329 278.955 171.696C286.741 166.738 315.721 163.02 315.721 163.02L313.487 156.332L352.34 143.961V143.937Z",
    fill: "#263238",
    style: (_ref48 = {
      fill: "#263238"
    }, _defineProperty(_ref48, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref48, "fillOpacity", 1), _ref48)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.46 186.755C331.797 188.534 321.58 189.344 312.751 189.823C311.56 175.341 318.842 161.461 318.842 161.461L329.206 158.798L339.448 186.755H339.46Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.681 237.55L407.799 244.275L392.338 247.515L391.221 240.79L406.681 237.55Z",
    fill: "#E4897B",
    style: (_ref49 = {
      fill: "#E4897B"
    }, _defineProperty(_ref49, "fill", "color(display-p3 0.8941 0.5373 0.4824)"), _defineProperty(_ref49, "fillOpacity", 1), _ref49)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.116 244.52C408.116 244.52 407.994 244.459 407.932 244.483C407.871 244.508 407.834 244.569 407.834 244.643C407.834 244.753 407.932 247.502 408.792 248.3C408.964 248.46 409.16 248.545 409.381 248.533C409.762 248.521 409.922 248.337 409.983 248.177C410.167 247.735 409.823 246.95 409.369 246.201C408.939 245.514 408.411 244.852 408.104 244.52H408.116ZM408.19 245.097C409.013 246.079 409.897 247.551 409.688 248.055C409.664 248.116 409.602 248.202 409.369 248.214C409.246 248.214 409.123 248.165 409.013 248.067C408.939 248.005 408.878 247.92 408.816 247.821C408.399 247.146 408.239 245.809 408.19 245.097Z",
    fill: "#407BFF",
    style: (_ref50 = {
      fill: "#407BFF"
    }, _defineProperty(_ref50, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref50, "fillOpacity", 1), _ref50)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.068 244.483C408.068 244.483 407.958 244.471 407.909 244.508C407.847 244.557 406.386 245.674 406.226 246.778C406.177 247.122 406.263 247.416 406.46 247.686C406.73 248.042 406.988 248.03 407.16 247.956C407.884 247.662 408.277 245.502 408.167 244.606C408.167 244.582 408.167 244.557 408.142 244.545C408.13 244.52 408.093 244.496 408.068 244.483ZM406.546 246.827C406.644 246.103 407.454 245.318 407.86 244.962C407.86 245.944 407.467 247.49 407.037 247.674C407 247.686 406.89 247.736 406.718 247.502C406.693 247.478 406.681 247.453 406.669 247.416C406.558 247.245 406.521 247.048 406.558 246.827H406.546Z",
    fill: "#407BFF",
    style: (_ref51 = {
      fill: "#407BFF"
    }, _defineProperty(_ref51, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref51, "fillOpacity", 1), _ref51)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.951 244.422L403.046 238.09C402.899 237.857 402.936 237.55 403.144 237.353L407.59 233.034C408.056 232.592 408.806 232.678 409.137 233.23C410.5 235.537 412.404 238.924 414.172 241.796C416.235 245.159 418.212 247.944 420.631 251.872C422.093 254.252 420.103 256.4 419.268 255.529C415.474 251.602 413.091 247.969 408.253 245.539C407.725 245.269 407.246 244.925 406.939 244.422H406.951Z",
    fill: "#263238",
    style: (_ref52 = {
      fill: "#263238"
    }, _defineProperty(_ref52, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref52, "fillOpacity", 1), _ref52)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.341 143.937C352.341 143.937 364.818 176.004 343.77 188.448C343.77 188.448 343.5 225.51 348.829 229.843C355.313 235.132 402.751 237.82 402.751 237.82L402.333 249.589C402.333 249.589 351.543 253.749 336.168 248.226C318.166 241.771 314.15 156.859 314.15 156.859L352.353 143.924L352.341 143.937Z",
    fill: "#263238",
    style: (_ref53 = {
      fill: "#263238"
    }, _defineProperty(_ref53, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref53, "fillOpacity", 1), _ref53)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M337.912 163.622L345.489 161.327C345.489 161.327 346.533 167.843 346.52 171.341L343.008 174.36L339.68 173.304C339.68 173.304 338.772 166.334 337.912 163.634V163.622Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.992 156.344L316.974 159.461L314.162 160.32L313.18 157.24L315.992 156.344Z",
    fill: "#263238",
    style: (_ref54 = {
      fill: "#263238"
    }, _defineProperty(_ref54, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref54, "fillOpacity", 1), _ref54)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.922 152.196L329.978 155.423L318.373 159.019L317.342 155.902L328.922 152.196Z",
    fill: "#263238",
    style: (_ref55 = {
      fill: "#263238"
    }, _defineProperty(_ref55, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref55, "fillOpacity", 1), _ref55)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.375 147.557L344.431 150.944L331.451 154.97L330.42 151.717L343.375 147.557Z",
    fill: "#263238",
    style: (_ref56 = {
      fill: "#263238"
    }, _defineProperty(_ref56, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref56, "fillOpacity", 1), _ref56)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.936 147.999L345.942 150.478H345.93L344.861 147.078L352.794 144.538L353.936 147.999Z",
    fill: "#263238",
    style: (_ref57 = {
      fill: "#263238"
    }, _defineProperty(_ref57, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref57, "fillOpacity", 1), _ref57)
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.992 156.344L316.974 159.461L314.162 160.32L313.18 157.24L315.992 156.344Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.922 152.196L329.978 155.423L318.373 159.019L317.342 155.902L328.922 152.196Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.375 147.557L344.431 150.944L331.451 154.97L330.42 151.717L343.375 147.557Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.936 147.999L345.942 150.478H345.93L344.861 147.078L352.794 144.538L353.936 147.999Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.138 244.005C307.199 243.992 307.249 243.931 307.261 243.87C307.261 243.808 307.236 243.735 307.175 243.71C307.077 243.649 304.658 242.36 303.528 242.692C303.294 242.765 303.123 242.888 303.024 243.084C302.84 243.428 302.926 243.649 303.024 243.784C303.319 244.164 304.166 244.275 305.038 244.25C305.849 244.226 306.696 244.103 307.126 244.005H307.138ZM306.61 243.784C305.345 243.992 303.626 244.029 303.294 243.587C303.258 243.526 303.209 243.428 303.319 243.232C303.38 243.121 303.479 243.047 303.626 242.998C303.724 242.974 303.823 242.962 303.933 242.949C304.731 242.925 305.959 243.465 306.598 243.772L306.61 243.784Z",
    fill: "#407BFF",
    style: (_ref58 = {
      fill: "#407BFF"
    }, _defineProperty(_ref58, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref58, "fillOpacity", 1), _ref58)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.2 243.968C307.2 243.968 307.273 243.882 307.261 243.821C307.261 243.747 307.028 241.919 306.143 241.219C305.873 241.01 305.566 240.925 305.247 240.961C304.805 241.023 304.682 241.244 304.658 241.428C304.547 242.201 306.217 243.637 307.052 243.98C307.077 243.98 307.101 243.993 307.114 243.993C307.15 243.993 307.175 243.993 307.212 243.956L307.2 243.968ZM305.947 241.477C306.524 241.931 306.794 243.023 306.893 243.551C306.045 243.072 304.903 241.931 304.977 241.477C304.977 241.44 305.001 241.33 305.284 241.293C305.321 241.293 305.345 241.293 305.382 241.293C305.591 241.293 305.775 241.354 305.947 241.489V241.477Z",
    fill: "#407BFF",
    style: (_ref59 = {
      fill: "#407BFF"
    }, _defineProperty(_ref59, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref59, "fillOpacity", 1), _ref59)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.802 243.036L315.244 242.864C315.526 242.864 315.772 243.048 315.833 243.318L317.319 249.344C317.479 249.969 317.012 250.571 316.373 250.583C313.684 250.595 309.804 250.534 306.439 250.62C302.497 250.718 299.095 251.013 294.466 251.123C291.666 251.184 290.831 248.386 291.985 248.104C297.29 246.815 301.637 246.582 306.169 243.637C306.66 243.318 307.213 243.085 307.802 243.072V243.036Z",
    fill: "#263238",
    style: (_ref60 = {
      fill: "#263238"
    }, _defineProperty(_ref60, "fill", "color(display-p3 0.1490 0.1961 0.2196)"), _defineProperty(_ref60, "fillOpacity", 1), _ref60)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M352.341 143.937L313.487 156.307C313.487 156.307 306.635 149.594 297.142 142.145C295.337 140.734 293.446 139.298 291.481 137.874C288.718 135.861 285.82 133.886 282.873 132.057C282.873 132.057 293.581 106.936 307.138 104.702C307.138 104.702 342.173 115.269 352.341 143.937Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M297.144 142.145C295.338 140.733 293.447 139.298 291.482 137.874L292.244 135.579C292.244 135.579 295.51 138.328 297.144 142.145Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.011 167.769L238.334 168.407C237.671 168.567 237.155 169.107 237.044 169.794L236.443 173.525C236.32 174.31 236.75 175.084 237.486 175.378L239.439 176.163C239.439 176.163 245.088 180.238 249.865 177.612L247.802 172.15L243.762 168.493C243.012 167.818 241.981 167.548 240.999 167.782L241.011 167.769Z",
    fill: "#E4897B",
    style: (_ref61 = {
      fill: "#E4897B"
    }, _defineProperty(_ref61, "fill", "color(display-p3 0.8941 0.5373 0.4824)"), _defineProperty(_ref61, "fillOpacity", 1), _ref61)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.775 133.051C293.213 135.113 293.508 139.359 293.508 139.359C293.508 139.359 290.807 146.674 289.247 150.318C288.179 152.785 287.086 155.264 285.796 157.731C284.47 160.222 283.193 162.652 281.019 165.352L280.602 165.855L280.098 166.395C279.791 166.739 279.349 167.144 278.907 167.524C278.723 167.696 278.379 167.941 278.097 168.138C277.814 168.334 277.434 168.592 277.311 168.629L276.267 169.169C274.916 169.844 273.651 170.384 272.374 170.899C269.857 171.93 267.352 172.826 264.847 173.697C259.824 175.378 254.826 176.913 249.693 178.201L247.262 171.635C251.867 169.279 256.558 167.046 261.138 164.751C263.434 163.609 265.719 162.468 267.904 161.314C268.985 160.738 270.066 160.136 270.987 159.572L271.65 159.155C271.834 159.056 271.687 159.105 271.674 159.105C271.65 159.105 271.588 159.179 271.625 159.118C271.662 159.056 271.699 159.032 271.822 158.872L271.969 158.688L272.141 158.43C273.136 156.982 274.265 154.773 275.236 152.613C276.206 150.404 277.188 148.109 278.085 145.765C279.865 141.102 281.584 136.23 283.181 131.517C283.181 131.517 286.128 130.867 289.763 133.051H289.775Z",
    fill: "#407BFF",
    style: (_ref62 = {
      fill: "#407BFF"
    }, _defineProperty(_ref62, "fill", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref62, "fillOpacity", 1), _ref62)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M289.775 133.051C293.213 135.113 293.508 139.359 293.508 139.359C293.508 139.359 290.807 146.674 289.247 150.318C288.179 152.785 287.086 155.264 285.796 157.731C284.47 160.222 283.193 162.652 281.019 165.352L280.602 165.855L280.098 166.395C279.791 166.739 279.349 167.144 278.907 167.524C278.723 167.696 278.379 167.941 278.097 168.138C277.814 168.334 277.434 168.592 277.311 168.629L276.267 169.169C274.916 169.844 273.651 170.384 272.374 170.899C269.857 171.93 267.352 172.826 264.847 173.697C259.824 175.378 254.826 176.913 249.693 178.201L247.262 171.635C251.867 169.279 256.558 167.046 261.138 164.751C263.434 163.609 265.719 162.468 267.904 161.314C268.985 160.738 270.066 160.136 270.987 159.572L271.65 159.155C271.834 159.056 271.687 159.105 271.674 159.105C271.65 159.105 271.588 159.179 271.625 159.118C271.662 159.056 271.699 159.032 271.822 158.872L271.969 158.688L272.141 158.43C273.136 156.982 274.265 154.773 275.236 152.613C276.206 150.404 277.188 148.109 278.085 145.765C279.865 141.102 281.584 136.23 283.181 131.517C283.181 131.517 286.128 130.867 289.763 133.051H289.775Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3432_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1484 440.78L259.13 439.024L372.027 347.189L384.367 363.72L406.684 257.191L296.412 255.879L312.428 273.721L94.1484 440.78Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M65.1973 458.696H245.554L371.657 356.898L387.154 376.055L414.686 249.368L284.96 249.626L300.445 268.783L65.1973 458.696Z",
    fill: "url(#paint9_radial_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M60.973 451.394H209.88C209.807 450.768 209.77 450.13 209.77 449.48C209.77 439.92 217.518 432.176 227.085 432.176C227.293 432.176 227.502 432.2 227.711 432.213C229.884 426.396 235.472 422.248 242.054 422.248C250.515 422.248 257.367 429.095 257.367 437.551C257.367 437.551 257.367 437.576 257.367 437.588C264.87 437.932 270.875 443.92 271.268 451.407H271.968C276.205 451.407 279.668 454.867 279.668 459.101C279.668 463.335 276.205 466.796 271.968 466.796H60.973C56.7364 466.796 53.2734 463.335 53.2734 459.101C53.2734 454.867 56.7364 451.407 60.973 451.407V451.394Z",
    fill: "url(#paint10_linear_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M60.973 451.394H209.88C209.807 450.768 209.77 450.13 209.77 449.48C209.77 439.92 217.518 432.176 227.085 432.176C227.293 432.176 227.502 432.2 227.711 432.213C229.884 426.396 235.472 422.248 242.054 422.248C250.515 422.248 257.367 429.095 257.367 437.551C257.367 437.551 257.367 437.576 257.367 437.588C264.87 437.932 270.875 443.92 271.268 451.407H271.968C276.205 451.407 279.668 454.867 279.668 459.101C279.668 463.335 276.205 466.796 271.968 466.796H60.973C56.7364 466.796 53.2734 463.335 53.2734 459.101C53.2734 454.867 56.7364 451.407 60.973 451.407V451.394Z",
    fill: "url(#paint11_radial_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3432_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.203 412.097L386.211 436.127L460.459 375.358L464.529 380.81L471.888 345.68L435.524 345.247L440.805 351.131L364.203 412.097Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M359.375 411.479L386.438 440.233L460.436 377.909L465.546 384.226L474.626 342.449L431.846 342.534L436.952 348.851L359.375 411.479Z",
    fill: "url(#paint12_radial_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.57 419.843C377.055 414.246 370.846 410.511 363.758 410.511C356.67 410.511 350.249 414.375 346.77 420.124C345.856 419.866 344.895 419.726 343.899 419.726C338.029 419.726 333.261 424.48 333.261 430.357C333.261 430.357 333.261 430.357 333.261 430.369H327.649C324.732 430.369 322.342 432.758 322.342 435.673C322.342 438.588 324.732 440.977 327.649 440.977H347.004C350.53 446.503 356.705 450.192 363.746 450.192C369.299 450.192 374.325 447.908 377.922 444.232C378.262 444.255 378.59 444.279 378.93 444.279C385.713 444.279 391.22 438.787 391.22 431.996C391.22 425.768 386.58 420.639 380.558 419.843H380.57Z",
    fill: "url(#paint13_linear_3432_330)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M380.57 419.843C377.055 414.246 370.846 410.511 363.758 410.511C356.67 410.511 350.249 414.375 346.77 420.124C345.856 419.866 344.895 419.726 343.899 419.726C338.029 419.726 333.261 424.48 333.261 430.357C333.261 430.357 333.261 430.357 333.261 430.369H327.649C324.732 430.369 322.342 432.758 322.342 435.673C322.342 438.588 324.732 440.977 327.649 440.977H347.004C350.53 446.503 356.705 450.192 363.746 450.192C369.299 450.192 374.325 447.908 377.922 444.232C378.262 444.255 378.59 444.279 378.93 444.279C385.713 444.279 391.22 438.787 391.22 431.996C391.22 425.768 386.58 420.639 380.558 419.843H380.57Z",
    fill: "url(#paint14_radial_3432_330)",
    style: {}
  }))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3432_330",
    x: 46.3535,
    y: 238.422,
    width: 219.4,
    height: 178.387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3432_330"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3432_330",
    x: 77.1484,
    y: 238.879,
    width: 346.535,
    height: 218.901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_3432_330"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3432_330",
    x: 347.203,
    y: 328.247,
    width: 141.686,
    height: 124.879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_3432_330"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3432_330",
    x1: 443.532,
    y1: 165.684,
    x2: 443.532,
    y2: 199.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref63 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref63, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref63, "stopOpacity", 1), _ref63)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3432_330",
    x1: 81.714,
    y1: 136.537,
    x2: 81.714,
    y2: 170.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref64 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref64, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref64, "stopOpacity", 1), _ref64)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3432_330",
    x1: 179.359,
    y1: 44.3721,
    x2: 179.359,
    y2: 84.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref65 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref65, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref65, "stopOpacity", 1), _ref65)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3432_330",
    x1: 382.851,
    y1: 55.2607,
    x2: 382.851,
    y2: 96.8515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref66 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref66, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref66, "stopOpacity", 1), _ref66)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3432_330",
    x1: 114.681,
    y1: 227.562,
    x2: 114.681,
    y2: 255.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref67 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref67, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref67, "stopOpacity", 1), _ref67)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3432_330",
    x1: 249.999,
    y1: 450.854,
    x2: 249.999,
    y2: 478.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref68 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref68, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref68, "stopOpacity", 1), _ref68)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3432_330",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.054 391.169) rotate(-90) scale(128.214 158.983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref69 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref69, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref69, "stopOpacity", 1), _ref69)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref70 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref70, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref70, "stopOpacity", 1), _ref70)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3432_330",
    x1: 50.3527,
    y1: 384.731,
    x2: 50.3527,
    y2: 418.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref71 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref71, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref71, "stopOpacity", 1), _ref71)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3432_330",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3527 414.22) rotate(-90) scale(25.4176 43.4236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref72 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref72, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref72, "stopOpacity", 1), _ref72)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref73 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref73, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref73, "stopOpacity", 1), _ref73)
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3432_330",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.942 432.005) rotate(-90) scale(157.425 262.832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref74 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref74, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref74, "stopOpacity", 1), _ref74)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref75 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref75, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref75, "stopOpacity", 1), _ref75)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3432_330",
    x1: 166.47,
    y1: 422.248,
    x2: 166.47,
    y2: 466.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref76 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref76, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref76, "stopOpacity", 1), _ref76)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3432_330",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.47 461.115) rotate(-90) scale(33.5025 170.259)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref77 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref77, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref77, "stopOpacity", 1), _ref77)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref78 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref78, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref78, "stopOpacity", 1), _ref78)
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3432_330",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(417 402.677) rotate(-90) scale(51.9138 86.6738)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref79 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref79, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref79, "stopOpacity", 1), _ref79)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref80 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref80, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref80, "stopOpacity", 1), _ref80)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3432_330",
    x1: 356.781,
    y1: 410.511,
    x2: 356.781,
    y2: 450.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref81 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref81, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref81, "stopOpacity", 1), _ref81)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3432_330",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(356.781 445.132) rotate(-90) scale(29.8415 51.7995)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref82 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref82, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref82, "stopOpacity", 1), _ref82)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref83 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref83, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref83, "stopOpacity", 1), _ref83)
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3432_330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 614,
    height: 458,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-57 21)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBae2);
export default __webpack_public_path__ + "static/media/BAE-2.be27a414b89cd1dc9dd3b643724aeb0d.svg";
export { ForwardRef as ReactComponent };